
export default

	props: section: Object

